const stats = [
  { label: "Signature Dishes", value: "24" },
  { label: "Handpicked Traditional Recipes", value: "" },
  { label: " Authentic Village-Style Kitchen", value: "" },
];

const Hero = ({ sectionRef }) => {
  return (
    <section
      id="home"
      ref={sectionRef}
      className="hero-section relative min-h-screen flex items-center lg:pt-0 lg:pb-0"
    >
      <div 
        className="absolute inset-0 bg-cover bg-center" 
        style={{
          backgroundImage: "url('https://images.pexels.com/photos/3535383/pexels-photo-3535383.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundColor: '#000',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          willChange: 'transform',
          imageRendering: 'crisp-edges',
          contentVisibility: 'auto'
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-hero-gradient" />
      <div className="container mt-[-70px] relative z-10 grid gap-12 lg:grid-cols-2 pt-0 pb-0 lg:py-28">
        <div className="space-y-8">
          <p className="text-sm uppercase pt-[150px] md:pt-[0px] tracking-[0.4em] text-brand-gold/80">
            pannai veetu biryani Legacy Since 1965
          </p>
          <h1 className="hero-heading text-4xl md:text-6xl font-display leading-tight text-brand-cream">
            The Soul of Authentic  
            <br />Pannai Veetu Biryani
          </h1>
          <p className="text-lg text-brand-cream/80 max-w-xl">
           Experience the purity of home-style biryani made with age-old 
            Pannai Veedu traditions. Each pot is slow-cooked in firewood,
            layered with aromatic seeraga samba rice, farm-fresh spices, 
            and the love of Tamil home kitchens.
          </p>
          <div className="hero-cta flex flex-wrap gap-4">
            <a
              href="#menu"
              className="px-8 py-3 rounded-full bg-brand-gold text-brand-maroon font-medium shadow-glow hover:translate-y-1 transition transform"
            >
                View Biryani Menu
            </a>
            <a
              href="#about"
              className="px-8 py-3 rounded-full border border-brand-gold/60 text-brand-cream hover:bg-white/10 transition"
            >
               Our Heritage
            </a>
          </div>
          <div className="hero-stats  grid grid-cols-2 sm:grid-cols-3 gap-6 text-brand-cream/80">
            {stats.map((item) => (
              <div key={item.label} className="p-4 rounded-2xl glass-panel border border-white/10">
                <p className="text-3xl font-display text-brand-gold">{item.value}</p>
                <p className="text-xs uppercase tracking-[0.3em] text-brand-cream/60">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="relative mt-10 lg:mt-0">
          <div className="hero-image rounded-[32px] overflow-hidden shadow-soft border border-white/10">
            <img
              src="https://images.pexels.com/photos/776538/pexels-photo-776538.jpeg?auto=compress&cs=tinysrgb&w=900"
              alt="Fine Dining"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -left-6 -bottom-6 bg-white/10 border border-white/10 rounded-3xl p-6 backdrop-blur-xl max-w-xs">
            <p className="text-sm uppercase tracking-[0.3em] text-brand-gold">Chef's Note</p>
            <p className="text-brand-cream/80 mt-2">
              “Firewood. Seeraga Samba. Amma’s Masala.  
              That’s our secret. Biryani ku athu tha da soul.”
            </p>
            <p className="mt-4 text-brand-gold font-semibold">Chef Arumugam Pannaiyar</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
